Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-header-notification');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var model = null;

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("headerNotification", model);
        wrapper.bind(html);

    };

    wrapper.bind = function (html) {
        $wrapper.html(html);

        $('.js-close-header-notification', $wrapper).on('click', function () {
            $('.js-header-notification', $wrapper).removeClass('visible');

            sessionStorage.setItem('noHeaderNotification', true);
        });
    };

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, $wrapper, function (envelope) {
        model = envelope.message.data;

        var flag = sessionStorage.getItem('noHeaderNotification');

        if (model.CheckoutStatus.IsDisabled && (model.CheckoutStatus.Reason === 'DailyTradingLimitReached' || model.CheckoutStatus.Reason === 'TradingRestriction' )&& flag === null) {
            wrapper.update();
        }
    });

});